<!--
  功能：自然语言预览页面
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2024-06-06 10:09:45
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div
    class="zryz-bg index-info"
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
  >
    <!-- 头部信息  -->
    <div class="info-header">
      <navigation :text="'自然语言解析结果'" :searchShow="false"></navigation>
    </div>
    <!-- 内容部分 -->
    <div class="info-content">
      <div class="content-desc">
        自然语言解析除了以下语句，请确认是否仅使用可回测的语句生成自定义因子，点击保存后系统会自动帮您用可回测的语句重新梳理自然语言：
      </div>
      <div class="content-list">
        <div class="list-title">
          <span class="title-icon"></span>
          <span class="title-text">可回测</span>
        </div>
        <div class="list-info">
          <van-row gutter="8">
            <van-col span="8" v-for="(item, index) in backtestYz" :key="index" class="list-col">
              <div class="list-item">{{ item.name }}</div>
            </van-col>
            <van-col></van-col>
          </van-row>
        </div>
        <div v-show="notBacktestYz.length > 0" style="margin-top: 35px">
          <div class="list-title">
            <span class="title-icon"></span>
            <span class="title-text">不可回测</span>
          </div>
          <div class="list-info">
            <van-row gutter="8">
              <van-col
                span="8"
                v-for="(item2, index2) in notBacktestYz"
                :key="index2"
                class="list-col"
              >
                <div class="list-item">{{ item2.name }}</div>
              </van-col>
              <van-col></van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="sub-but">
      <van-button round type="info" color="#286df7" class="sub-but-style" @click="showDialog = true"
        >保存自定义因子</van-button
      >
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="showDialog"
      title="保存自然语言自定义因子"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <div class="dialog-content">
        <div class="dialog-name">自定义因子名称</div>
        <div><van-field v-model="nameText" class="dialog-input" placeholder="请输入名称" /></div>
        <div class="dialog-but">
          <van-button type="default" class="dialog-but-style dialog-but-close" @click="closeDialog"
            >取消</van-button
          >
          <van-button
            type="default"
            class="dialog-but-style dialog-but-sub"
            :loading="subServerLoading"
            loading-text="保存中..."
            :disabled="nameText == ''"
            @click="subDialog"
            >确认</van-button
          >
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import navigation from '@/components/navigation.vue';
import { addNatureLanguage } from '@/api/factor.js';
export default {
  name: '',
  components: { navigation },
  data() {
    return {
      // message 自然语言输入的内容
      zryyText: '',

      // 解析完的数据
      analyzeData: {},
      // 解析的因子 ID
      FactorIDs: '',
      // 解析出的可回测因子
      backtestYz: [],
      // 解析出的不可回测因子
      notBacktestYz: [],
      // 选中
      resultSelect: [],
      // 弹框
      showDialog: false,
      //   标题名称
      nameText: '',
      //   提交 loading
      subServerLoading: false
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    // 获取 vuex 中的数据
    if (this.$store.state.zryyData) {
      this.analyzeData = this.$store.state.zryyData.analyzeData;
      this.zryyText = this.$store.state.zryyData.zryyText;
      this.resultSelect = this.$store.state.zryyData.resultSelect;
      this.FactorIDs = this.$store.state.zryyData.analyzeData.FactorIDs;
      this.backtestYz = this.$store.state.zryyData.analyzeData.backtestYz;
      this.notBacktestYz = this.$store.state.zryyData.analyzeData.notBacktestYz;
    }
  },
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {},
  // 组件方法
  methods: {
    closeDialog: function () {
      this.showDialog = false;
    },
    // 提交
    subDialog: function () {
      if (this.nameText == '') {
        return false;
      }
      this.subServerLoading = true;
      let params = {
        yz_name: this.nameText,
        backtestYz: JSON.stringify(this.backtestYz),
        notBacktestYz: JSON.stringify(this.notBacktestYz),
        FactorIDs: this.FactorIDs,
        Description: this.analyzeData.Description,
        condition_info: this.analyzeData.condition_info,
        yz_input: this.zryyText
      };
      addNatureLanguage(params)
        .then((result) => {
          this.subServerLoading = false;
          if (result.err == 200) {
            // 关闭当前页面 跳转到 因子详情页面
            window.location.href = 'dzh_browser_url&goto=0&screen=484&type=1';
          } else {
            this.$toast.fail(result.msg);
          }
        })
        .catch((err) => {
          this.subServerLoading = false;
          this.$toast.fail('创建失败!');
        });
    }
  }
};
</script>

<style scoped lang="less">
.zryz-bg {
  height: 100vh;
  overflow: hidden;
  background-color: #e9eff8;
  background-image: url('../../assets/image/zryy/zryy-bg.png');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100%; /* 背景图宽度自适应 */
  background-attachment: fixed;
  position: relative;
  //  头部
  .info-header {
    margin-top: 44px;
  }
  //  内容部分
  .info-content {
    padding: 0;
    .content-desc {
      padding: 16px;
      color: #4e5969;
      font-size: 13px;
    }
    .content-list {
      height: 100vh;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 8px;
      padding: 16px;
      .list-title {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
        .title-icon {
          width: 4px;
          height: 15px;
          background: #286df7;
          display: inline-block;
        }
        .title-text {
          color: #1d2129;
          font-size: 16px;
          font-weight: 500;
          margin-left: 4px;
        }
      }
      .list-info {
        margin-top: 16px;
        .list-item {
          background: #f2f3f6;
          border-radius: 4px;
          color: #4b5768;
          font-size: 14px;
          text-align: center;
          height: 36px;
          line-height: 36px;
          margin-bottom: 8px;
          // 文字溢出隐藏显示...
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          display: -webkit-box;
          -webkit-line-clamp: 1; // 超出多少行
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

// 提交按钮
.sub-but {
  height: 46px;
  width: 100%;
  position: absolute;
  bottom: 30px;
  text-align: center;
  .sub-but-style {
    width: 80%;
    font-weight: 500;
    color: #ffffff;
    font-size: 16px;
    font-family: 'dzhbd';
  }
}

// 弹窗样式
.dialog-content {
  padding: 16px;
  .dialog-name {
    color: #4e5969;
    font-size: 14px;
    margin-bottom: 4px;
  }
  .dialog-input {
    border: 0.5px solid #e5e6eb;
    border-radius: 4px;
  }
  .dialog-but {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .dialog-but-style {
      width: 45%;
      border-radius: 6px;
    }
    .dialog-but-close {
      background: rgba(0, 0, 0, 0.06);
      color: #1d2129;
      font-size: 14px;
    }
    .dialog-but-sub {
      background: #286df7;
      color: #ffffff;
      font-size: 14px;
    }
    .van-button--disabled {
      background: #286df7 !important;
      opacity: 0.5 !important;
      color: #ffffff !important;
      border: 1px solid #286df7 !important;
    }
  }
}

// 黑版
.black_theme {
  background-color: #0b172c;
  background-image: url('../../assets/image/zryy/zryy-bg-black.png');
  // 导航
  .navget_main {
    color: #ffffff;
  }

  .info-content {
    .content-desc {
      color: #c9cbdc;
    }
    .content-list {
      background: rgba(255, 255, 255, 0.1);
      .list-title {
        .title-icon {
          background: #3b85fe;
        }
        .title-text {
          color: #e4e9fe;
        }
      }
      .list-info {
        .list-item {
          background: rgba(242, 243, 246, 0.04);
          color: #c9cbdc;
        }
      }
    }
  }

  // 弹窗样式
  .dialog-content {
    .dialog-name {
      color: #c9cbdc;
    }
    .dialog-input {
      border: 0.5px solid;
      border-color: rgba(255, 255, 255, 0.1);
      background-color: rgba(255, 255, 255, 0);
      ::v-deep {
        .van-field__control {
          color: #ffffff;
        }
      }
    }
    .dialog-but {
      .dialog-but-close {
        background: rgba(255, 255, 255, 0.06);
        border: 0px;
        color: #e4e9fe;
      }
      .dialog-but-sub {
        background: #3b85fe;
        border: 0px;
      }
    }
  }
  ::v-deep {
    .van-dialog__header {
      color: #e4e9fe;
    }
  }
}
</style>
